import type { ReactNode } from 'react';

import {
  DropdownMenuItem as BaseDropdownMenuItem,
  DropdownMenuSeparator as BaseDropdownMenuSeparator,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/shared/components/shadcn/dropdown-menu';

interface ContextMenuProps {
  isOpen: boolean;
  onClose: () => void;
  onUnmount: () => void;
  position: { x: number; y: number };
  children: ReactNode;
  className?: string;
}

interface ContextMenuItemProps {
  children: ReactNode;
  icon?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

interface ContextMenuSeparatorProps {
  className?: string;
}

function ContextMenuRoot({
  isOpen,
  onClose,
  onUnmount,
  position,
  children,
  className,
}: ContextMenuProps) {
  return (
    <DropdownMenu open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DropdownMenuTrigger asChild>
        <div
          className="invisible fixed"
          style={{
            left: `${position.x}px`,
            top: `${position.y}px`,
            width: '0px',
            height: '0px',
          }}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent className={className} onCloseAutoFocus={onUnmount}>
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

function ContextMenuItem({ children, icon, onClick, disabled, className }: ContextMenuItemProps) {
  return (
    <BaseDropdownMenuItem
      className={className || 'flex items-center gap-2'}
      onClick={onClick}
      disabled={disabled}
    >
      {icon}
      {children}
    </BaseDropdownMenuItem>
  );
}

function ContextMenuSeparator({ className }: ContextMenuSeparatorProps) {
  return <BaseDropdownMenuSeparator className={className} />;
}

// Export compound component
export const ContextMenu = Object.assign(ContextMenuRoot, {
  Item: ContextMenuItem,
  Separator: ContextMenuSeparator,
});
